import { createFileRoute } from '@tanstack/react-router';

import { FEATURE_FLAGS } from 'shared/consts';
import { revalidateLocationCapabilities, TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';
import { routes } from 'shared/routes';
import { requireFeatureFlag } from 'shared/utils';

import { LocalRankTracker } from 'features/reports/LocalRankTracker';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/lrt')({
  staticData: { breadcrumb: 'localRankTracker' },
  beforeLoad: ({ context }) =>
    requireFeatureFlag(FEATURE_FLAGS.LRT_ALLOWED, context.authUser.featureAllowance, {
      fallbackRoute: routes.locations()
    }),
  // The gate reads the location capabilities; refreshing them here keeps the page from rendering empty
  // or from stale access first.
  loader: ({ context: { queryClient }, params: { id } }) =>
    revalidateLocationCapabilities({ queryClient, locationId: id }),
  component: LocalRankTrackerRoute
});

function LocalRankTrackerRoute() {
  const { id } = Route.useParams();

  return (
    <ToolAccessGate
      gate={TOOL_GATES.LOCAL_RANK_TRACKER}
      locationId={id}
      page={LOCATION_DATA_UNAVAILABLE_PAGE.LOCAL_RANK_TRACKER}
    >
      <LocalRankTracker locationId={id} />
    </ToolAccessGate>
  );
}
